import { ButtonBase, IconButton, Paper, styled as muiStyled } from '@mui/material'
import styled from 'styled-components'

export const MoodCardQuestion = styled.div`
  color: #fff;
  text-align: center;
  font-family: Outfit;
  font-size: 14px;
  line-height: 15px;
  cursor: default;
  @media (min-width: 1296px) {
    font-size: 28px;
    line-height: 35px;
  }
`

export const MoodCardOptionImage = styled.img`
  width: 30px;
  cursor: pointer;
  @media (min-width: 1296px) {
    width: 45px;
  }
`

export const MoodCardAnswer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  height: 100%;
`

export const MentalStateTypeQuestion = styled.div`
  color: #fff;
  text-align: center;
  font-family: Outfit;
  font-size: 14px;
  cursor: default;
  @media (min-width: 768px) {
    font-size: 22px;
  }
  @media (min-width: 1080px) {
    font-size: 28px;
  }
`

export const MentalStateTypeModalMUIPaper = muiStyled(Paper)(
  ({ opacity }) => `
    background: #424572;
    max-width: 400px !important;
    max-height: 165px !important;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 0!important;
    border-radius: 36px;
    opacity: ${opacity};
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    padding:20px;
    @media(min-width: 768px){
        max-width: 500px !important;
        max-height: 200px !important;
    }
  `,
)

export const MentalStateTypeButton = muiStyled(ButtonBase)(
  ({ theme }) => `
        font-family: 'Outfit';
        font-size: 14px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        max-width: 150px;
        max-height: 40px;
        display: flex;
        justify-content: center;
        align-items:center;
        align-self: center;
        border-radius: 8px;
        background: #fff;
        color: #000;
        border: 1px #000 solid;
        transition: all 400ms ${theme.transitions.easing.quickInOut};
        gap: 8px;
        @media (min-width: 768px) {
            font-size: 18px;
            max-width: 130px;
            max-height: 50px !important;
        }
        &:hover{
            background: #d9dff0;
            border: 1px #d9dff0 solid;
        }
  `,
)

export const MentalStateTypeBackButtonContainer = muiStyled(IconButton)(
  () => `

`,
)
